<script>
import moment from "moment/moment";

export default {
  props: {
    status: {
      type: String,
      default: '0',
    }
  },
  data(){
    return {
      baseUrl: "/api/sfa/v1/daily-closing/monitoring-salesman-not-yet-end-session",
      approve: 1,
      reject: 2,
      table: {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "created_at",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      },
    }
  },
  methods: {
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangeLength(val) {
      this.table.length = val === "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    setStartEnd() {
      let valStart =
          this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(date) {
      let a = null;
      if (date != null) {
        a = moment(date).format("YYYY-MM-DD");
      }
      return a;
    },
    getData(){
      this.$vs.loading();
      this.$http
          .get(`${this.baseUrl}/approval`, {
            params: {
              length: this.table.length,
              page: this.table.page,
              search: this.table.search,
              order: this.table.order,
              sort: this.table.sort,
              status: this.status,
            },
          })
          .then((resp) => {
            if (resp.code == 200) {
              this.table.total = resp.data.total_record;
              this.table.totalPage = resp.data.total_page;
              this.table.totalSearch = resp.data.total_record_search;
              this.table.length = resp.data.total_record_per_page;
              this.table.data = resp.data.records;
              this.setStartEnd();
              this.$vs.loading.close();
            } else {
              console.log(resp.data);
            }
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log(error);
          });
    },
    handleApproval(id, status){
      let title = ''
      let message = 'Are you sure you want to'
      switch (status) {
        case this.approve:
          title = 'Confirm Approval';
          message = `${message} confirm approval?`
          break
        case this.reject:
          title = 'Reject Approval'
          message = `${message} reject approval?`
          break;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: title,
        text: message,
        accept: () => {
          this.$nextTick( () => {
            this.processApproval(id, status)
          })
        }
      })
    },
    processApproval(id, status){
      this.$vs.loading();
      let param = {
        force_end_session_id: id,
        approval_status: status
      };
      this.$http
          .post(`${this.baseUrl}/approval`, param)
          .then((resp) => {
            if (resp.code == 200) {
              this.getData()
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
              this.$vs.loading.close();
            } else {
              this.getData()
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
              this.$vs.loading.close();
            }
          })
          .catch((error) => {
            this.getData()
            console.log(error);
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: error,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.$vs.loading.close();
          });
    }
  },
  mounted(){

  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
}
</script>

<template>
  <div class="vx-row mb-12">
    <div class="core vx-col md:w-1/1 w-full mb-base">
      <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
                <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                  {{ this.table.total }}</span
                >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangeLength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>

        <template slot="thead">
          <vs-th width="10%" v-show="status==0">Action</vs-th>
          <!-- <vs-th sort-key width="5%">No</vs-th> -->
          <vs-th sort-key="territory">Territory</vs-th>
          <vs-th sort-key="salesman">Salesman Name</vs-th>
          <vs-th sort-key="date">Date</vs-th>
          <vs-th sort-key="date">Reason</vs-th>
          <vs-th sort-key="approved_by" v-show="status==1">Approved By</vs-th>
          <vs-th sort-key="approved_at" v-show="status==1">Approved At</vs-th>
          <vs-th sort-key="rejected_by" v-show="status==2">Rejected By</vs-th>
          <vs-th sort-key="rejected_at" v-show="status==2">Rejected At</vs-th>
          <!-- <vs-th sort-key>Work Operation</vs-th>
          <vs-th sort-key>Receive Time</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="whitespace-no-wrap" v-show="status == 0">
              <div class="vx-input-group flex">
                <vx-tooltip text="Reject">
                  <vs-button size="small" color="danger" icon-pack="feather"
                             icon="icon-x" title="Reject" style="margin-right: 5px" @click="handleApproval(tr.ID, reject)" />
                </vx-tooltip>
                <vx-tooltip text="Approve">
                  <vs-button size="small" color="success" icon-pack="feather"
                             icon="icon-check" title="Approve" style="margin-right: 5px" @click="handleApproval(tr.ID, approve)" />
                </vx-tooltip>
              </div>
            </vs-td>
            <vs-td>{{ tr.TerritoryCode }} - {{ tr.TerritoryName }}</vs-td>
            <vs-td>{{ tr.PersonalName }}</vs-td>
            <vs-td>{{ tr.Date }}</vs-td>
            <vs-td>{{ tr.Reason }}</vs-td>
            <vs-td v-show="status == 1 || status == 2">{{ tr.Updated_By }}</vs-td>
            <vs-td v-show="status == 1 || status == 2">{{ dateFormat(tr.Updated_At) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
      />
    </div>
  </div>
</template>